module.exports = __webpack_public_path__ + "img/accordo.7fde89a3.jpg";